<template>
  <div id="app">
    <!-- Preloader Start -->
    <div class="preloader">
      <div class="loading-container">
        <div class="loading"></div>
        <div id="loading-icon">
          <img src="/assets/images/IMG_6555.png" alt="">
        </div>
      </div>
    </div>
    <!-- Preloader End -->

    <!-- Header Start -->
    <header class="main-header">
      <div class="mov">
        <nav class="navbar navbar-expand-lg">
          <div class="container">
            <!-- Logo Start -->
            <router-link class="navbar-brand" to="/">
              <img src="/assets/images/IMG_6556.png" alt="Logo" height="50">
            </router-link>
            <!-- Logo End -->

            <!-- Main Menu Start -->
            <div class="collapse navbar-collapse main-menu">
              <div class="nav-menu-wrapper">
                <ul class="navbar-nav mr-auto" id="menu">
                  <li class="nav-item"><router-link class="nav-link" to="/">Inicio</router-link></li>
                  <li class="nav-item"><a class="nav-link" href="#about">¿Quienes somos?</a></li>
                  <li class="nav-item"><a class="nav-link" href="#services">Nuestros servicios</a></li>
                  <li class="nav-item"><a class="nav-link" href="#whyus">¿Porque Nosotros?</a></li>
                  <li class="nav-item"><a class="nav-link" href="#metricas">Metricas</a></li>
                  <li class="nav-item"><a class="nav-link" href="#contact">Contacto</a></li>
                </ul>
              </div>

              <!-- Header Btn Start -->
              <div class="header-btn">
                <a href="http://wa.me/529933402976" class="btn-default">Escribenos WA</a>
              </div>
              <!-- Header Btn End -->
            </div>
            <!-- Main Menu End -->
            <div class="navbar-toggle"></div>
          </div>
        </nav>
        <div class="responsive-menu"></div>
      </div>
    </header>
    <!-- Header End -->

    <!-- Router View con transición Fade -->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <!-- Scroll to Top Button -->
    <button
      :class="{ show: showScrollButton }"
      @click="scrollToTop"
      class="scroll-to-top"
    >
      ↑
    </button>

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: { Footer },
  data() {
    return {
      showScrollButton: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showScrollButton = window.scrollY > 200
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style>
.mov {
  position: relative;
  top: auto;
}

/* Fade transition para router-view */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Scroll to Top Button */
.scroll-to-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  background-color: #0174bc;
  color: white;
  border: none;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
  opacity: 0;               /* inicial invisible */
  pointer-events: none;      /* no clickeable mientras invisible */
  transition: opacity 0.5s ease, transform 0.3s ease;
}

.scroll-to-top.show {
  opacity: 1;               /* visible */
  pointer-events: auto;     /* clickeable */
}

.scroll-to-top:hover {
  transform: translateY(-3px);
}
</style>
